import { useCallback, useState } from 'react';
import { DonViTinh } from '@/types/schemas/don-vi-tinh.type';
import { useAuth } from '@/contexts/auth-context';
import api from '@/lib/api';

export const useDonViTinh = () => {
  const { entity } = useAuth();
  const [donViTinhs, setDonViTinhs] = useState<DonViTinh[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDonViTinhs = useCallback(async () => {
    if (!entity?.slug) return [];

    setIsLoading(true);
    try {
      const response = await api.get(`entities/${entity.slug}/erp/units/`, {
        params: { page_size: 1000 }
      });
      const data = response.data.results || [];
      setDonViTinhs(data);
      return data;
    } catch (error) {
      console.error('Error fetching units:', error);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, [entity?.slug]);

  return {
    donViTinhs,
    isLoading,
    fetchDonViTinhs
  };
};
